import { Link } from 'react-router-dom';
import { Header } from '../landingPage/Header';

interface ToolsLayoutProps {
  children: React.ReactNode;
}

export function ToolsLayout({ children }: ToolsLayoutProps) {
  return (
    <div className="min-h-screen bg-background text-foreground flex flex-col">
      <Header
        onLoginClick={() => window.location.href = '/editor'}
        onTryFreeClick={() => window.location.href = '/editor'}
      />
      <main className="flex-1 w-full max-w-7xl mx-auto px-4 md:px-6 lg:px-8 py-8 md:py-12">
        {children}
      </main>
      <footer className="border-t border-border py-8">
        <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <Link to="/" className="flex items-center gap-2">
            <div className="w-6 h-6 bg-orange-500 rounded-md flex items-center justify-center text-white font-bold text-sm">
              R
            </div>
            <span className="font-semibold text-sm text-foreground">reelcat</span>
          </Link>
          <p className="text-sm text-muted-foreground">
            Free online video tools powered by AI
          </p>
        </div>
      </footer>
    </div>
  );
}
